module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-Heavy.6d024ab.woff";